"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadSegment = void 0;
/* eslint-disable */
var railsEnv_1 = require("./railsEnv");
var SEGMENT_METHODS = [
    'trackSubmit',
    'trackClick',
    'trackLink',
    'trackForm',
    'pageview',
    'identify',
    'reset',
    'group',
    'track',
    'ready',
    'alias',
    'debug',
    'page',
    'once',
    'off',
    'on',
    'addSourceMiddleware',
    'addIntegrationMiddleware',
    'setAnonymousId',
    'addDestinationMiddleware',
];
var RESET_PASSWORD_TOKEN_REGEX = /reset_password_token=[a-zA-Z0-9_\-\.]+?(?=&|$)/;
var ACCESS_TOKEN_REGEX = /access_token=[a-zA-Z0-9_\-\.]+?(?=&|$)/;
// Allow running in node for server-side rendering
if (typeof window !== 'undefined') {
    // This block taken from https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/quickstart/#step-2-add-the-segment-snippet ,
    // and modified to remove defensive code that prevents it being initialized twice
    var segment_1 = [];
    // don't clobber existing window.analytics if it exists (useful when an app loads segment)
    // in a custom way. In the future we should have apps load this object explicitly (only once)
    // in the head.
    window.analytics = window.analytics || segment_1;
    // Define a factory to create stubs. These are placeholders
    // for methods in Analytics.js so that you never have to wait
    // for it to load to actually record data. The `method` is
    // stored as the first argument, so segment can replay the data.
    segment_1.factory = function (method) {
        return function () {
            var args = Array.prototype.slice.call(arguments);
            args.unshift(method);
            segment_1.push(args);
            return segment_1;
        };
    };
    // For each segment method, generate a queueing stub.
    for (var i = 0; i < SEGMENT_METHODS.length; i++) {
        var key = SEGMENT_METHODS[i];
        segment_1[key] = segment_1.factory(key);
    }
    segment_1.SNIPPET_VERSION = '4.15.2';
    // we don't want local storage fallbacks for our ajs_anonymous_id and ajs_user_id
    // cookies, since local storage isn't sent with server requests (so we can have
    // user and experiment switching). See go/anonymous_id
    segment_1._loadOptions = { user: { localStorageFallbackDisabled: true } };
    segment_1.page({
        url: window.location.href
            .replace(RESET_PASSWORD_TOKEN_REGEX, 'reset_password_token=REDACTED')
            .replace(ACCESS_TOKEN_REGEX, 'access_token=REDACTED'),
        search: window.location.search
            .replace(RESET_PASSWORD_TOKEN_REGEX, 'reset_password_token=REDACTED')
            .replace(ACCESS_TOKEN_REGEX, 'access_token=REDACTED'),
    });
}
// The segment script overwrites window.analytics with a new object, so we can't
// directly export the `segment` object. Instead, export an object that delegates
// to `window.analytics`
var segmentWrapper = {};
SEGMENT_METHODS.forEach(function (methodName) {
    segmentWrapper[methodName] = function () {
        // @ts-expect-error fix later
        var _a;
        (_a = window.analytics)[methodName].apply(_a, arguments);
    };
});
// Define a method to load Analytics.js from segment CDN
//
// The default source that tracking events are sent to is
// Web Market JS Prod (DWH: web_js_production) in production and
// Web Market JS Staging (DWH: web_js_staging) in staging.
// The request to load the script is proxied via Cloudflare Worker
// in order to circumvent ad blockers.
//
// To send tracking events to other sources, pass the source's
// write key to this function. The request to load the script
// may be blocked by ad blockers.
var loadSegment = function (key) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    if (key) {
        script.src =
            ('https:' === document.location.protocol ? 'https://' : 'http://') +
                'trkcdn.opendoor.com/analytics.js/v1/' +
                key +
                '/analytics.min.js';
    }
    else {
        script.src =
            ('https:' === document.location.protocol ? 'https://' : 'http://') +
                ((0, railsEnv_1.getRailsEnv)() === 'production' ? 'www.opendoor.com' : 'demo.simplersell.com') +
                '/_scripts/sgm.min.js';
    }
    // Insert our script next to the first script element.
    var first = document.getElementsByTagName('script')[0];
    // @ts-expect-error fix me
    first.parentNode.insertBefore(script, first);
};
exports.loadSegment = loadSegment;
exports.default = segmentWrapper;
//# sourceMappingURL=segment.js.map